import { supabaseAuthProvider } from "ra-supabase";
import { supabase } from './supabase';

const authProvider = supabase ? supabaseAuthProvider(supabase, {}) : undefined;

export default authProvider;
